export default "/assets/Icon/flowWallet.png"